import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpFloatingButtonComponent } from './fcp-floating-button.component';
import { FcpIconModule } from '../fcp-icon';

const components = [FcpFloatingButtonComponent];
@NgModule({
    declarations: components,
    exports: components,
    imports: [CommonModule, FcpIconModule]
})
export class FcpFloatingButtonModule {}
